module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('blockquote', [_c('p', {
    staticClass: "noind",
    attrs: {
      "id": "start"
    }
  }, [_vm._v("Scientists at Columbia University’s Lamont-Doherty Earth Observatory have found that the Earth’s inner core is rotating faster than the planet itself. The Earth’s solid iron inner core . . . is surrounded by a much larger liquid outer core, and together the two form a giant electrical motor. . . . About a billion amps of current is flowing . . . across the boundary between the inner and outer cores. . . . ‘The really surprising thing is how fast the core is moving,’ said seismologist Paul Richards, who along with fellow seismologist Xiaodong Song made the discovery. . . . Over the past 100 years that extra speed has given the core a quarter turn on the planet as a whole. . . . [T]he motion is about 100,000 times faster than the drift of continents. . . . [Each] year, the inner core rotates about one longitudinal degree more than the Earth’s mantle and crust. . . . Pressure at the inner core surface is millions of times higher than the atmospheric pressure at Earth’s surface. . . . The mass of the inner core is about one hundred million million million tons—which is about 30 per cent greater than the mass of the moon.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("—Excerpt from a Columbia University")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("press release dated July 18, 1996.")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("The foregoing results were confirmed by subsequent research at Columbia University and the University of Illinois at Urbana-Champaign, as described in an article in the August 26, 2005, issue of "), _c('i', [_vm._v("Science")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7076db82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5start.vue
// module id = 78
// module chunks = 0